import { Box, Text } from '@mantine/core';
import 'ace-builds/src-noconflict/ace';
import 'ace-builds/src-noconflict/ext-searchbox';
import 'ace-builds/src-noconflict/mode-nunjucks';
import 'ace-builds/src-noconflict/theme-tomorrow';
import { Field } from 'formik';
import 'jsoneditor-react/es/editor.min.css';
import { useState } from 'react';
import AceEditor from 'react-ace';
import { nunjucksParser } from 'components/IntegrationsDashboard/utils';

export const Editor = props => {
  return (
    <AceEditor
      theme="tomorrow"
      fontSize={14}
      style={{
        lineHeight: '2',
        width: '100%',
      }}
      name="Tranformation_editor"
      editorProps={{ $blockScrolling: true, required: true }}
      setOptions={{
        enableBasicAutocompletion: true,
        enableLiveAutocompletion: true,
        enableSnippets: true,
        highlightGutterLine: true,
        highlightActiveLine: true,
        mode: 'ace/mode/nunjucks',
        highlightSelectedWord: true,
        required: true,
      }}
      {...props}
    />
  );
};

export const TransformationEditor = ({ name, withFormik = true, ...restProps }) => {
  const [validationError, setValidationError] = useState<any>();

  return (
    <Box style={{ margin: '20px 0px' }}>
      <Text weight={500} size="sm">
        Transformation Editor
      </Text>
      <Text weight={500} size="sm" color="red">
        {validationError}
      </Text>
      {withFormik ? (
        <Field name={name}>
          {({ field, form }) => {
            return (
              <Editor
                value={field.value}
                onChange={(code, event) => {
                  setValidationError(nunjucksParser(code));
                  form.setFieldValue(field.name, code);
                }}
                {...restProps}
              />
            );
          }}
        </Field>
      ) : (
        <Editor {...restProps} />
      )}
    </Box>
  );
};
